import './App.css';
import Footer from './components/Footer/Footer';
import Reasons from './components/Header/Reasons/Reasons';
import Hero from './components/Hero/Hero';
import Join from './components/Join/Join';
import Plans from './components/Plans/Plans';
import Testimonials from './components/Plans/Testimonials/Testimonials';
import Programs from './components/Programs/Programs';
function App() {
  return (
    <div className="App">
      <Hero/>
      <Programs/>
      <Reasons/>
      <Plans/>
      <Testimonials/>
      <Join/>
      <Footer/>
    </div>
  );
}

export default App;
